<div class="not-found-container">
  <h1>404</h1>
  <h2>Página no encontrada</h2>

  <p>
    Lo sentimos, la página que buscas no existe o fue movida.
  </p>
</div>
